import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_msgbox_message_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  message_hdr_guid: fromDatatype.GuidDataFieldInterface;
  msgbox_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_msgbox_message_link_RowClass implements bl_msg_msgbox_message_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  message_hdr_guid: fromDatatype.GuidDataFieldInterface;
  msgbox_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

